import { Paper } from '@mui/material';
import EditDetails from './edit-details';
import type { FlowSlotDto } from '@/types/dtos/flows/response/flow.dto';
import type { ScheduleInlineDetailsTab } from './edit-details/schedule-inline-details-tab';

interface EditDetailsPanelProps {
  slot?: FlowSlotDto;
  slotTitle: string;
  onSlotDeleted?: () => void;
  onSessionPublishSuccess?: () => void;
  eventSlotIdParam?: string | null;
  /** Narrow layout: panel under a slot row (not a full-height column). */
  variant?: 'column' | 'inline';
  /** When `variant` is `inline`, show one session widget at a time (tabs controlled from slot row). */
  inlineScheduleDetailsTab?: ScheduleInlineDetailsTab;
}

export default function EditDetailsPanel({
  slot,
  slotTitle,
  onSlotDeleted,
  onSessionPublishSuccess,
  eventSlotIdParam,
  variant = 'column',
  inlineScheduleDetailsTab,
}: EditDetailsPanelProps) {
  return (
    <Paper elevation={0} sx={{ height: variant === 'inline' ? 'auto' : '100%', px: 0 }}>
      <EditDetails
        selectedSlot={slot}
        slotTitle={slotTitle}
        onSlotDeleted={onSlotDeleted}
        onSessionPublishSuccess={onSessionPublishSuccess}
        eventSlotIdParam={eventSlotIdParam}
        inlineScheduleDetailsTab={variant === 'inline' ? inlineScheduleDetailsTab : undefined}
      />
    </Paper>
  );
}
